const initialState = { loading: true, loggedIn: false, me: {} };

function authentication(state = initialState, action) {
  let decodedToken;
  let identityToken;
  let user;
  switch (action.type) {
    case 'redux-oidc/USER_FOUND':
      decodedToken = JSON.parse(atob(action.payload.access_token.split('.')[1]));
      identityToken = JSON.parse(atob(action.payload.id_token.split('.')[1]));
      if (decodedToken === null) {
        console.log('Session expired | nullToken');
        return {
          loading: false,
          loggedIn: false,
          error: 'There\'s a problem with the session. Please contact support'
        };
      }

      if (!decodedToken.AccountID) {
        // Once a user is created in Orion their id will be mapped to the
        // token when Identity server retrieves claims from the /users/claims endpoint in Orion API.
        console.error('AccountID is missing. A new user needs to be'
          + ' created in the Orion portal and mapped to this account.');

        return {
          loading: false,
          loggedIn: false,
          error: 'Your account is registered and pending confirmation from support.',
          me: {}
        };
      }

      user = {
        accountID: decodedToken.AccountID,
        role: identityToken.role,
        name: identityToken.name,
        email: identityToken.email,
        token: action.payload.access_token
      };

      return {
        loading: false,
        loggedIn: true,
        me: user
      };

    case 'redux-oidc/LOADING_USER':
      return { loading: true, loggedIn: false, me: {} };

    case 'redux-oidc/USER_EXPIRED':
      return { loading: false, loggedIn: false, me: {} };

    default:
      return state;
  }
}

export default authentication;
